// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { ButtonPresentationProps } from "@insite/mobius/Button";
import { orderTotalDisplaySharedStyles } from "@steiner/App/SharedStyles/OrderTotalDisplaySharedStyles";
import { cartTotalStyles } from "@steiner/Overrides/Widgets/Cart/CartTotal";
import { addToCartButtonStyles } from "@steiner/XDL/PreStyle/button";
import { avoidBreakInsidePrintElement, color, hideElement, hideElementOnPrint, mergeWithCss } from "@steiner/XDL/Utilities";
import { css } from "styled-components";

const sharedButtonStyle: ButtonPresentationProps = {
    variant: "tertiary",
    css: css`
        width: 100%;
        ${hideElementOnPrint}
    `,
};

cartTotalStyles.container = {
    css: css`
        display: flex;
        flex-direction: column;
        gap: 12px;

        @media print {
            max-width: 100%;
        }
        ${avoidBreakInsidePrintElement}
    `,
};

cartTotalStyles.submitQuoteButton = {
    ...sharedButtonStyle,
};

cartTotalStyles.checkoutButton = {
    ...mergeWithCss(addToCartButtonStyles, {
        css: css`
            width: 100%;
            ${hideElementOnPrint}
        `,
    }),
};

cartTotalStyles.cancelPunchOutButton = {
    ...sharedButtonStyle,
};

cartTotalStyles.submitQuoteButton = {
    ...sharedButtonStyle,
};

cartTotalStyles.saveOrderButton = {
    ...sharedButtonStyle,
};

cartTotalStyles.submitRequisitionButton = {
    ...sharedButtonStyle,
};

cartTotalStyles.styledHr = {
    ...orderTotalDisplaySharedStyles.styledHr,
};

cartTotalStyles.styledHrGridItem = {
    ...mergeWithCss(orderTotalDisplaySharedStyles.styledHrGridItem, {
        css: css`
            ${hideElementOnPrint}
        `,
    }),
};

cartTotalStyles.fullWidthGridItem = {
    ...mergeWithCss(orderTotalDisplaySharedStyles.fullWidthGridItem, {
        css: css`
            ${hideElementOnPrint}
        `,
    }),
};

cartTotalStyles.continueShoppingLink = {
    typographyProps: {
        size: 12,
        lineHeight: "15px",
    },
};

cartTotalStyles.continueShoppingLinkWrapper = {
    css: css`
        text-align: left;
    `,
};

cartTotalStyles.cartTotalContainer = {
    css: css`
        &&&& {
            & > div:first-child {
                margin-bottom: 10px;
                background-color: ${color("common.ui14")};
            }
        }
    `,
};
